import { Api } from '@axiom/ui';
import type { Candidate, Education, EducationEdit } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class EducationApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  async createEducation(candidateId: Candidate['id'], body: EducationEdit) {
    return super.write<{ data: Education }>({
      endpoint: `/candidates/${candidateId}/degrees`,
      body,
      method: 'POST',
    });
  }

  async updateEducation(
    educationId: Education['id'],
    body: Partial<EducationEdit>
  ) {
    return super.write<{ data: Education }>({
      endpoint: `/education/${educationId}`,
      body,
      method: 'PATCH',
    });
  }

  async deleteEducation(educationId: Education['id']) {
    return super.write<{ data: Education }>({
      endpoint: `/education/${educationId}`,
      method: 'DELETE',
    });
  }
}

export const EducationApi = new EducationApiClass();
